// extracted by mini-css-extract-plugin
export default {"footerBg":"oa-z","footerTopLinks":"pa-z","footerFeedback":"qa-z","footerSocial":"ra-z","footerLegalLinks":"sa-z","footerIconCards":"ta-z","footerBotCopy":"ua-z"};